import React from 'react'

function UserSubscriptionsPage() {
  return (
    <div>UserSubscriptionsPage</div>
  )
}

export default UserSubscriptionsPage;